var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLevel2 = function SvgLevel2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z",
    fill: "url(#Level_2_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.006 39.588c10.825 0 19.6-8.776 19.6-19.6 0-10.826-8.775-19.601-19.6-19.601-10.825 0-19.6 8.775-19.6 19.6 0 10.825 8.775 19.6 19.6 19.6Z",
    fill: "url(#Level_2_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.682 19.898c0 .751-.044 1.546-.133 2.252-.088.84-.265 1.634-.441 2.473a8.89 8.89 0 0 1-.31 1.015c-.176.618-.44 1.236-.706 1.81a20.823 20.823 0 0 1-2.075 3.62 21.878 21.878 0 0 1-2.34 2.606c-3.311 3.046-7.726 4.9-12.583 4.944-4.857 0-9.272-1.81-12.627-4.856-.839-.795-1.634-1.634-2.34-2.56a17.522 17.522 0 0 1-2.958-5.785c-.31-.97-.53-2.03-.662-3.046a19.45 19.45 0 0 1-.133-2.296C1.33 9.788 9.674 1.4 19.962 1.355c10.287-.044 18.676 8.256 18.72 18.543Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17 19.987c0-7.648 6.188-13.836 13.836-13.836 7.648 0 13.835 6.188 13.835 13.836 0 7.648-6.187 13.836-13.835 13.836-7.648 0-13.836-6.188-13.836-13.836Z",
    fill: "url(#Level_2_svg__c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.842 19.987c0 7.346-6.081 13.26-13.548 13.26-7.505 0-13.547-5.952-13.547-13.26 0-7.345 6.08-13.259 13.547-13.259 7.467 0 13.548 5.914 13.548 13.26Z",
    fill: "url(#Level_2_svg__d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.006 33.188c7.29 0 13.201-5.91 13.201-13.2 0-7.291-5.91-13.202-13.201-13.202S6.805 12.696 6.805 19.987s5.91 13.201 13.2 13.201Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Level_2_svg__e",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 28,
    height: 28
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.006 33.188c7.29 0 13.201-5.91 13.201-13.2 0-7.291-5.91-13.202-13.201-13.202S6.805 12.696 6.805 19.987s5.91 13.201 13.2 13.201Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Level_2_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M.844 44.623C6.937 30.01 15.547 17.691 25.878 9.17a57.09 57.09 0 0 1 3.797-2.87l-.353-.485C27.202 2.989 24.686.958 21.904-.19l-.309-.132c-2.781-1.148-5.607-1.325-8.433-.53l-.662.176-9.05 7.462-.442.75c-1.943 3.135-3.312 6.756-4.062 10.862l-.088.353-.089.353c-.794 4.062-.883 8.256-.353 12.362l.133.972-1.987 10.375 4.282 1.81Z",
    fill: "url(#Level_2_svg__f)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.068 28.309c.084-.045.335-.179.418-.58.126-.581-.083-1.877-.083-1.877s-.419.447-.586.983c-.168.402.042.982.167 1.295-.376-.67-.711-1.34-.962-2.01.084 0 .335-.134.502-.447.21-.49.21-1.697.21-1.697s-.461.358-.754.804c-.21.357-.126.849-.042 1.162-.25-.626-.46-1.251-.627-1.877a.652.652 0 0 0 .543-.357c.293-.446.46-1.563.46-1.563s-.501.268-.836.67c-.251.268-.251.714-.251.982-.168-.58-.251-1.16-.335-1.742a.69.69 0 0 0 .544-.268c.335-.402.67-1.429.67-1.429s-.544.223-.921.536c-.21.179-.335.491-.377.76-.041-.537-.083-1.073-.083-1.52.125 0 .376 0 .586-.178.418-.313.878-1.34.878-1.34s-.586.134-1.004.402c-.251.134-.377.447-.46.67 0-.223 0-.402.042-.58 0-.313.041-.626.083-.894.126 0 .377.045.628-.134.46-.268 1.088-1.25 1.088-1.25s-.586.044-1.088.312c-.293.134-.502.491-.586.715.084-.626.21-1.162.335-1.608.042.044.376.134.711-.045.502-.223 1.34-1.161 1.34-1.161s-.629 0-1.13.178c-.46.179-.754.715-.88.938.252-.848.46-1.429.586-1.697.126-.09.377-.223.586-.536.377-.58.837-2.01.837-2.01s-.837.76-1.255 1.34a1.469 1.469 0 0 0-.251 1.206c-.126.268-.335.804-.586 1.608.042-.223.126-.849-.084-1.25a3.862 3.862 0 0 0-.67-.894s-.125 1.385.168 1.876a.78.78 0 0 0 .586.402 27.917 27.917 0 0 0-.377 1.742c0-.268-.041-.715-.292-1.027-.335-.402-.795-.76-.795-.76s.083 1.296.46 1.742c.209.268.502.313.586.313-.042.313-.084.58-.084.938 0 .268-.042.536-.042.849-.042-.268-.125-.715-.418-1.028-.377-.357-.92-.67-.92-.67s.292 1.251.71 1.653c.251.268.586.268.628.268 0 .625.042 1.25.126 1.965-.042-.134-.168-.848-.628-1.16-.418-.358-1.004-.582-1.004-.582s.46 1.251.92 1.608c.335.268.67.18.712.18.083.58.209 1.25.376 1.875-.084-.268-.335-.76-.753-1.027a5.912 5.912 0 0 0-1.046-.536s.628 1.25 1.13 1.563c.334.224.627.134.711.134.167.625.377 1.296.67 1.965-.126-.223-.46-.803-.921-1.027a6.703 6.703 0 0 0-1.13-.447s.837 1.251 1.381 1.564c.377.223.67.09.711.044.293.67.628 1.385 1.046 2.1-.167-.224-.627-.849-1.13-1.027-.543-.224-1.171-.358-1.171-.358s1.046 1.296 1.632 1.519c.46.178.711-.045.753-.045.335.58.753 1.206 1.213 1.831l.084-.089c-.502-.804-.92-1.384-1.255-1.965Z",
    fill: "url(#Level_2_svg__g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.507 28.309c-.093-.045-.372-.179-.465-.58-.14-.581.093-1.877.093-1.877s.465.447.65.983c.187.402-.046.982-.185 1.295.418-.67.79-1.34 1.069-2.01-.093 0-.372-.134-.558-.447-.232-.49-.232-1.697-.232-1.697s.511.358.837.804c.232.357.139.849.046 1.162.279-.626.511-1.251.697-1.877a.74.74 0 0 1-.604-.357c-.325-.446-.511-1.563-.511-1.563s.557.268.93.67c.278.268.278.714.278.982.186-.58.28-1.16.372-1.742-.14 0-.418-.044-.604-.268-.372-.402-.744-1.429-.744-1.429s.604.223 1.023.536c.232.179.372.491.418.76.047-.537.093-1.073.093-1.52-.14 0-.418 0-.65-.178-.465-.313-.977-1.34-.977-1.34s.65.134 1.116.402c.279.134.418.447.511.67 0-.223 0-.402-.046-.58 0-.313-.047-.626-.093-.894-.14 0-.419.045-.698-.134-.511-.268-1.208-1.25-1.208-1.25s.65.044 1.208.312c.326.134.558.491.651.715a10.57 10.57 0 0 0-.372-1.608c-.046.044-.372.134-.79-.045-.558-.223-1.488-1.161-1.488-1.161s.698 0 1.255.178c.512.179.837.715.977.938-.28-.848-.512-1.429-.651-1.697-.14-.09-.418-.223-.65-.536-.42-.58-.93-2.01-.93-2.01s.93.76 1.394 1.34c.418.536.326 1.027.279 1.206.14.268.372.804.65 1.608-.046-.223-.139-.849.094-1.25.279-.492.744-.894.744-.894s.14 1.385-.186 1.876a.885.885 0 0 1-.651.402c.14.491.279 1.072.418 1.742 0-.268.047-.715.326-1.027.372-.402.883-.76.883-.76s-.093 1.296-.511 1.742a.937.937 0 0 1-.651.313c.046.313.093.58.093.938 0 .268.046.536.046.849.047-.268.14-.715.465-1.028.419-.357 1.023-.67 1.023-.67s-.326 1.251-.79 1.653c-.28.268-.651.268-.698.268 0 .625-.046 1.25-.14 1.965.047-.134.187-.848.698-1.16.465-.358 1.116-.582 1.116-.582s-.512 1.251-1.023 1.608c-.372.268-.744.18-.79.18-.093.58-.233 1.25-.419 1.875.093-.268.372-.76.837-1.027a6.888 6.888 0 0 1 1.162-.536s-.697 1.25-1.255 1.563c-.372.224-.697.134-.79.134a12.854 12.854 0 0 1-.744 1.965c.14-.223.511-.803 1.023-1.027.558-.268 1.255-.447 1.255-.447s-.93 1.251-1.534 1.564c-.419.223-.744.09-.79.044-.326.67-.698 1.385-1.163 2.1.186-.224.697-.849 1.255-1.027.605-.224 1.302-.358 1.302-.358s-1.162 1.296-1.813 1.519c-.511.178-.79-.045-.837-.045-.372.58-.837 1.206-1.348 1.831l-.093-.089c.558-.804.976-1.384 1.395-1.965Z",
    fill: "url(#Level_2_svg__h)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.46 33.76c.044-.18.09-.406.134-.586l.046-.225s-.496-.405-.676-.54c.18 0 .405-.045.585-.045l.27-.045.09-.225c.046-.18.136-.36.18-.54.09.18.406.765.406.765h.9l-.45.45-.18.18.09.225c.045.225.135.405.18.63-.18-.09-.405-.225-.585-.315l-.225-.135-.225.135c-.18.045-.36.18-.54.27ZM26.849 36.145c-.18-.135-.315-.315-.45-.45l-.18-.18-.225.09c-.18.045-.405.135-.585.18.09-.18.18-.36.315-.54l.135-.225s-.36-.54-.495-.676c.18.045.405.09.585.09l.27.045.135-.225c.09-.18.225-.315.315-.495.045.18.18.81.18.81l.225.045c.18.046.405.09.585.136-.18.09-.36.224-.54.315l-.225.135v.225c-.045.27-.045.495-.045.72ZM22.258 37.36c-.09-.18-.226-.405-.316-.585l-.135-.225h-.855l.45-.45.18-.18s-.225-.63-.27-.81l.54.27.225.09.18-.18c.135-.135.316-.27.45-.36 0 .18-.044.855-.044.855l.225.135c.18.09.36.225.54.315-.225.045-.405.09-.63.135l-.225.045-.046.225c-.135.27-.18.495-.27.72ZM17.576 37.315c-.044-.225-.09-.45-.18-.63l-.044-.225-.226-.045c-.18-.045-.405-.09-.585-.135.18-.09.36-.18.54-.315l.226-.135s-.045-.63-.045-.855c.134.135.27.27.45.405l.18.18.225-.09c.18-.09.36-.18.54-.225-.09.18-.27.81-.27.81l.18.18c.135.135.27.315.405.45-.225 0-.405 0-.63-.045h-.225l-.135.225c-.18.09-.315.27-.405.45ZM13.03 36.055v-.9l-.225-.135c-.18-.09-.36-.18-.54-.315.18-.045.405-.09.585-.135l.225-.045s.135-.63.18-.81c.09.18.225.314.315.494l.135.226.27-.046c.18-.045.405-.045.585-.09-.135.18-.495.676-.495.676l.135.225c.09.18.18.36.316.54-.18-.045-.406-.135-.586-.18l-.225-.09-.18.18c-.18.09-.36.27-.495.405ZM10.42 33.67c-.18-.135-.36-.225-.54-.36l-.225-.136-.225.136c-.18.09-.405.225-.585.315.045-.225.135-.406.18-.63l.09-.226-.18-.18-.45-.45h.9s.315-.585.405-.765c.045.18.135.36.18.54l.09.225.27.045c.18.045.405.045.585.045-.135.135-.675.54-.675.54l.045.225c.045.27.09.45.135.676ZM7.944 9.409l-.225.045c-.18.045-.405.045-.585.09.135-.18.27-.316.405-.496l.135-.18-.09-.225c-.09-.18-.18-.405-.27-.585.225.09.405.18.63.225l.225.09.18-.18c.135-.135.315-.27.495-.405 0 .225-.045.405-.045.63v.27s.54.36.72.45c-.18.045-.36.09-.585.135l-.225.045-.045.27c-.045.18-.09.36-.09.586-.27-.225-.63-.765-.63-.765ZM11.32 6.527l-.225-.045c-.18-.045-.405-.045-.63-.09.18-.135.315-.27.495-.36l.18-.135-.045-.225c-.045-.225-.09-.45-.09-.675l.54.405.18.135.225-.09c.18-.09.36-.18.585-.27-.09.18-.135.36-.225.585l-.09.225s.45.495.585.63h-.855l-.135.226-.27.54c0-.225-.225-.856-.225-.856ZM15.326 4.727l-.225-.09a2.26 2.26 0 0 0-.585-.225c.18-.09.405-.135.585-.225l.225-.09.045-.225c.045-.225.045-.45.09-.675l.406.54.135.18.225-.045c.225-.045.405-.09.63-.09-.135.18-.27.315-.36.495l-.135.18s.315.585.405.765c-.18-.045-.36-.135-.54-.18l-.225-.09-.18.18c-.135.135-.27.27-.405.45-.09-.18-.09-.855-.09-.855ZM20.817 4.907c-.18-.09-.314-.225-.495-.315l-.225-.135-.225.135c-.18.09-.315.225-.495.315.045-.18.18-.81.18-.81l-.18-.135c-.18-.135-.315-.27-.495-.36.225 0 .405-.045.63-.045h.225l.09-.225c.09-.225.18-.405.27-.63.09.225.18.405.225.63l.09.225.226.045c.225 0 .405.045.63.045-.18.135-.315.27-.495.36l-.18.135c.044-.045.18.585.224.765ZM24.283 4.997s-.63.18-.81.27c.09-.18.405-.765.405-.765s-.405-.54-.495-.675l.855.135.135-.18.405-.54c.045.225.045.45.09.675l.046.225.81.315c-.18.09-.36.135-.585.225l-.226.09s-.045.63-.045.855c-.18-.135-.585-.63-.585-.63ZM28.559 7.428l-.27-.54-.09-.226h-.855c.135-.135.585-.63.585-.63l-.09-.225c-.09-.18-.135-.405-.225-.585l.54.27.225.09.18-.135.54-.405c-.045.225-.09.45-.09.675l-.045.225.18.135c.18.135.315.27.495.36-.225 0-.405.045-.63.045l-.27.045c.135.09-.09.72-.18.9ZM31.71 10.219c-.045-.18-.045-.405-.09-.586l-.045-.27-.225-.045c-.18-.045-.36-.09-.585-.135.18-.09.72-.45.72-.45v-.27c0-.225-.045-.405-.045-.63.18.135.315.27.45.405l.18.18.225-.09c.225-.09.405-.135.63-.225-.09.18-.18.405-.27.585l-.09.225.135.18c.135.18.27.315.36.495a2.634 2.634 0 0 0-.585-.09l-.225-.045c-.045.09-.45.63-.54.766Z",
    fill: "#CECECE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.804 28.717H13.436V25.43l4.5-4.546c1.306-1.35 2.116-2.25 2.522-2.746.405-.495.675-.9.81-1.26s.225-.72.225-1.126c0-.495-.135-.855-.45-1.125s-.765-.405-1.306-.405c-.585 0-1.17.18-1.755.495s-1.26.81-2.026 1.486l-2.745-3.196c.945-.855 1.755-1.44 2.385-1.8.63-.36 1.35-.63 2.116-.856.765-.18 1.62-.27 2.566-.27 1.17 0 2.25.225 3.195.63a4.77 4.77 0 0 1 2.16 1.8 4.79 4.79 0 0 1 .766 2.611c0 .72-.09 1.396-.27 1.98a5.99 5.99 0 0 1-.855 1.801c-.36.585-.9 1.215-1.486 1.89-.63.676-1.98 1.891-4.006 3.737v.135h6.977v4.05h.045Z",
    fill: "url(#Level_2_svg__i)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_2_svg__a",
    x1: 4.48,
    y1: 4.473,
    x2: 43.042,
    y2: 43.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_2_svg__b",
    x1: 35.247,
    y1: 35.22,
    x2: -2.584,
    y2: -2.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_2_svg__c",
    x1: 30.529,
    y1: 28.765,
    x2: 9.67,
    y2: 11.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_2_svg__d",
    x1: 9.905,
    y1: 11.556,
    x2: 30.012,
    y2: 28.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_2_svg__g",
    x1: 8.779,
    y1: 26.256,
    x2: -3.338,
    y2: 20.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_2_svg__h",
    x1: 39.494,
    y1: 26.256,
    x2: 26.53,
    y2: 19.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_2_svg__i",
    x1: 30.618,
    y1: 24.567,
    x2: 14.248,
    y2: 5.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505050"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Level_2_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(30.76762 12.60486 -17.05579 41.63204 17.754 -.874)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
};
export default SvgLevel2;